(() => {
  'use strict';

  const mobile = window.matchMedia('(max-width: 749px)');
  let shadowRoot = null;
  let shadowObserver = null;

  const apply = () => {
    if (!shadowRoot) return;

    shadowRoot.querySelectorAll('.widgetLabel').forEach((label) => {
      if (mobile.matches) {
        label.style.setProperty('display', 'none', 'important');
        label.setAttribute('aria-hidden', 'true');
      } else {
        label.style.removeProperty('display');
        label.removeAttribute('aria-hidden');
      }
    });

    const launcher = shadowRoot.querySelector('[data-testid="widgetButtonBody"]');
    if (launcher && !launcher.getAttribute('aria-label')) {
      launcher.setAttribute('aria-label', 'Open chat widget');
    }
  };

  const attach = () => {
    const host = document.getElementById('tidio-chat');
    const nextRoot = host && host.shadowRoot;
    if (!nextRoot) return false;

    if (nextRoot !== shadowRoot) {
      shadowObserver?.disconnect();
      shadowRoot = nextRoot;
      shadowObserver = new MutationObserver(apply);
      shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
    }

    apply();
    return true;
  };

  const setMeta = (selector, attribute, value) => {
    document.querySelectorAll(selector).forEach((element) => {
      element.setAttribute(attribute, value);
    });
  };

  const applyPreviewIdentity = () => {
    const identities = {
      'review-find-my-trip': {
        title: "Find My Trip | Damesly Women's Group Travel",
        description: 'Explore scheduled Damesly group trips, share your travel preferences, or contact the team for personal guidance.',
        canonical: '/pages/custom-trip-planning?view=review-find-my-trip',
      },
      'review-hosted-trips': {
        title: 'Hosted Group Trips for Your Community | Damesly',
        description: 'Host a group trip with Damesly for your community. Bring your people and vision; we handle trip planning, logistics, bookings and traveler support.',
        canonical: '/pages/hosted-trips',
      },
      'review-referral-program': {
        title: 'Damesly Referral Program | Share the Adventure',
        description: 'Share Damesly with a friend. Explore how the referral program works, review the current benefits and eligibility, and read the full program terms.',
        canonical: '/pages/referral-program',
      },
      'review-travel-agents': {
        title: 'Travel Advisor Partnerships | Damesly',
        description: 'Connect your clients with Damesly\'s small-group trips for women. Explore our travel advisor program, how it works and how to get in touch with the team.',
        canonical: '/pages/travel-agents',
      },
    };
    const view = new URLSearchParams(window.location.search).get('view');
    const identity = identities[view];
    if (!identity) return;

    const canonical = new URL(identity.canonical, window.location.origin).href;
    document.title = identity.title;
    setMeta('meta[name="description"]', 'content', identity.description);
    setMeta('meta[property="og:title"]', 'content', identity.title);
    setMeta('meta[property="og:description"]', 'content', identity.description);
    setMeta('meta[property="og:url"]', 'content', canonical);
    setMeta('meta[name="twitter:title"]', 'content', identity.title);
    setMeta('meta[name="twitter:description"]', 'content', identity.description);
    setMeta('link[rel="canonical"]', 'href', canonical);
    document.documentElement.dataset.dameslyPreviewIdentity = view;
  };

  const applyClientPreview = () => {
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    document.querySelectorAll('.dv13__review-directory').forEach((directory) => {
      directory.hidden = !designMode;
      directory.setAttribute('aria-hidden', designMode ? 'false' : 'true');
      if (designMode) {
        directory.style.removeProperty('display');
      } else {
        directory.style.setProperty('display', 'none', 'important');
      }
    });

    const helpLink = document.querySelector('.dv13__hero-content .dv13__help');
    if (helpLink && !document.querySelector('.dv13__hero-phone-wrap')) {
      const wrapper = document.createElement('span');
      wrapper.className = 'dv13__hero-phone-wrap';
      wrapper.append(' or call ');

      const phone = document.createElement('a');
      phone.className = 'dv13__hero-phone';
      phone.href = 'tel:+14255324945';
      phone.textContent = '(425) 532-4945';
      wrapper.append(phone);
      helpLink.insertAdjacentElement('afterend', wrapper);
    }

    if (!document.getElementById('damesly-v13-client-preview-style')) {
      const style = document.createElement('style');
      style.id = 'damesly-v13-client-preview-style';
      style.textContent = '.dv13__hero-phone-wrap{display:inline-block;margin-left:4px}.dv13__hero-phone{text-decoration:underline;font-weight:800}@media(max-width:560px){.dv13__hero-phone-wrap{display:block;margin:10px 0 0}}';
      document.head.append(style);
    }

    applyPreviewIdentity();
  };

  const start = () => {
    applyClientPreview();
    if (attach()) return;

    const timer = window.setInterval(() => {
      if (attach()) window.clearInterval(timer);
    }, 250);

    window.setTimeout(() => window.clearInterval(timer), 30000);
  };

  if (mobile.addEventListener) mobile.addEventListener('change', apply);
  else mobile.addListener(apply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
